import React from 'react';
import StarRatings from 'react-star-ratings';
import { color } from '@core-ds/primitives';

export type StarsProps = {
   /** The rating. */
   rating: number;
   /** The color of each active star. */
   activeColor?: string;
   /** The number of total stars. */
   count?: number;
   /** The color of each inactive star. */
   inactiveColor?: string;
   /** Size in px of each star */
   size?: number;
   /** Spacing in px between each star */
   spacing?: number;
   /** Callback when a star is clicked. */
   onChange?: (newRating: number) => void;
};

const Stars = ({
   rating,
   activeColor = color.blue,
   count = 5,
   inactiveColor = color.gray3,
   size = 40,
   spacing = 0,
   onChange = null,
}: StarsProps) => (
   <StarRatings
      rating={rating}
      numberOfStars={count}
      changeRating={onChange}
      starDimension={`${size}px`}
      starEmptyColor={inactiveColor}
      starHoverColor={activeColor}
      starRatedColor={activeColor}
      starSpacing={`${spacing}px`}
      svgIconPath="M12 2a1 1 0 0 1 .896.555l2.547 5.126 5.7.827a1 1 0 0 1 .552 1.709l-4.12 3.985.972 5.628a1 1 0 0 1-1.448 1.056L12 18.223l-5.099 2.663a1 1 0 0 1-1.448-1.056l.972-5.628-4.12-3.985a1 1 0 0 1 .551-1.709l5.7-.827 2.549-5.126A1 1 0 0 1 12 2z"
      svgIconViewBox="0 0 24 24"
   />

   // This svg path is from the size 24 star-solid core component here:
   // icons/24/star-solid.svg (core-icons repo)
);

export default Stars;
